.remove-summary-button {
    margin-left: auto;
}

.last-loading-line-container {
    width: 80%;
    padding-bottom: 12px;
}

.summary-content-container {
    border-radius: 3px;
    border: 1px solid var(--ai-purple-pink);
    padding: 12px;
    background: linear-gradient(
            90deg,
            rgba(96, 43, 204, 0.04) 0%,
            rgba(139, 92, 246, 0.04) 50%,
            rgba(187, 151, 246, 0.04) 100%
        ),
        #fff;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
